exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._1dQuWULbj7cpE4ASoRKHvJ{height:100%;overflow-y:auto;padding:1.42857rem}._2k7X2omx_xLiIw4PPzpMfq{padding:0}._3tEwYnPx4cTB84SMrTEbmx{color:#0087e6;font-weight:600;text-decoration:none}._3JGJ1K9ORHOTIGToGY0JIc{color:#a4a4a4;display:inline}._1dQuWULbj7cpE4ASoRKHvJ._1NIlCBC33BUyP1ekNLpR6A{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;cursor:default;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;font-size:100%;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;white-space:nowrap}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"NotificationCalloutSlide": "_1dQuWULbj7cpE4ASoRKHvJ",
	"NotificationCalloutSlide_studentProfile": "_2k7X2omx_xLiIw4PPzpMfq",
	"NotificationCalloutSlide_openLink": "_3tEwYnPx4cTB84SMrTEbmx",
	"NotificationCalloutSlide_timestamp": "_3JGJ1K9ORHOTIGToGY0JIc",
	"__error": "_1NIlCBC33BUyP1ekNLpR6A"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/build-omni-operation-ui_develop/node_modules/omni-common-ui/postcss.config.js"}}!./containers/NotificationCalloutSlide/style.postcss
// module id = 2095
// module chunks = 0